/**
 * Smart Sticky Sidebar
 * Gère le cas où le contenu sticky est plus grand que le viewport
 * + auto-scroll quand un accordéon s'ouvre
 */
(function () {
  const SELECTOR = 'product-info.product__column-sticky';
  let sidebar = null;
  let lastScrollY = window.scrollY;
  let currentTop = 0;
  let ticking = false;

  function getHeaderHeight() {
    const val = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseFloat(val) || 0;
  }

  function update() {
    if (!sidebar || window.innerWidth < 750) {
      sidebar && sidebar.style.removeProperty('top');
      return;
    }

    const scrollY = window.scrollY;
    const delta = scrollY - lastScrollY;
    const vpHeight = window.innerHeight;
    const headerH = getHeaderHeight();
    const offset = headerH + 15;
    const sidebarHeight = sidebar.offsetHeight;

    if (sidebarHeight <= vpHeight - offset) {
      currentTop = offset;
    } else {
      if (delta > 0) {
        const minTop = vpHeight - sidebarHeight;
        currentTop = Math.max(currentTop - delta, minTop);
      } else {
        currentTop = Math.min(currentTop - delta, offset);
      }
    }

    sidebar.style.top = currentTop + 'px';
    lastScrollY = scrollY;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  function recalc() {
    requestAnimationFrame(update);
  }

  /**
   * Quand un accordéon s'ouvre, scroll pour montrer tout son contenu
   */
  function onAccordionToggle(e) {
    const details = e.target.closest('details');
    if (!details || !details.open || !sidebar || window.innerWidth < 750) return;

    // Attendre que le DOM se mette à jour
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const vpHeight = window.innerHeight;
        const headerH = getHeaderHeight();
        const detailsRect = details.getBoundingClientRect();
        const contentEl = details.querySelector('.collapsible__content');

        if (!contentEl) return;

        const contentRect = contentEl.getBoundingClientRect();
        const contentBottom = contentRect.bottom;
        const contentTop = detailsRect.top;

        // Si le contenu dépasse en bas du viewport
        if (contentBottom > vpHeight) {
          const contentHeight = contentRect.height;
          const summaryHeight = detailsRect.height - contentHeight;
          const availableSpace = vpHeight - headerH - 15;

          if (contentHeight + summaryHeight <= availableSpace) {
            // Tout l'accordéon (summary + contenu) peut tenir dans le viewport
            // → scroller pour que le bas du contenu soit visible
            const scrollAmount = contentBottom - vpHeight + 20; // 20px de marge
            window.scrollBy({ top: scrollAmount, behavior: 'smooth' });
          } else {
            // Le contenu est trop grand → montrer le haut du summary
            const scrollAmount = contentTop - headerH - 20;
            window.scrollBy({ top: scrollAmount, behavior: 'smooth' });
          }
        }
      });
    });
  }

  function init() {
    sidebar = document.querySelector(SELECTOR);
    if (!sidebar) return;

    const headerH = getHeaderHeight();
    currentTop = headerH + 15;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', recalc, { passive: true });

    const resizeObserver = new ResizeObserver(() => {
      recalc();
    });
    resizeObserver.observe(sidebar);

    // Écouter les toggle d'accordéons
    sidebar.addEventListener('toggle', onAccordionToggle, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();